/** `localStorage` key: set when the auto growers dashboard tour finished or was dismissed. */
export const GROWERS_HELP_TOUR_STORAGE_KEY = 'growers-dashboard-help-tour-completed';

/** DOM anchors for the growers dashboard help tour (`driver.js`). */
export const GROWERS_HELP_TOUR_IDS = {
    DETAIL: 'growers-help-tour-detail',
    EXPERT: 'growers-help-tour-expert',
    TABS: 'growers-help-tour-tabs',
    ADD_GROWER: 'growers-help-tour-add-grower',
} as const;
